(function () {
    'use strict';
    angular.module('app').directive('selectioncommandundocheckoutofunchangedchildren', selectioncommand_undocheckoutofunchangedchildren);
    function selectioncommand_undocheckoutofunchangedchildren() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                undoCheckOutOfUnchangedChildrenDialogShown: '=?'
            },
            controller: 'releasecheckout',
            templateUrl: 'app/selectioncommand/selectioncommand_undocheckoutofunchangedchildren.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();